import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { SocialIcons } from "./SocialIcons";

export const Footer = () => (
  <footer className="border-t border-gold-400/10 bg-navy-950 mt-8" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid grid-cols-1 md:grid-cols-3 gap-10 items-start">
      <div>
        <Logo size={96} />
        <p className="mt-5 text-sm text-slate-400 leading-relaxed max-w-xs">
          Cinematic, story-driven music — written where the sea meets the sky.
        </p>
      </div>
      <div className="flex flex-col gap-3 text-sm">
        <span className="eyebrow mb-1">Explore</span>
        {[
          ["Music", "/music", "footer-music-link"],
          ["News", "/news", "footer-news-link"],
          ["Bespoke Music", "/bespoke", "footer-bespoke-link"],
          ["About Me", "/about", "footer-about-link"],
          ["Press & Media", "/press", "footer-press-link"],
          ["Discover", "/discover", "footer-discover-link"],
          ["Contact", "/contact", "footer-contact-link"],
        ].map(([label, to, id]) => (
          <Link key={id} to={to} data-testid={id} className="text-slate-400 hover:text-gold-300 transition-colors w-fit">
            {label}
          </Link>
        ))}
      </div>
      <div>
        <span className="eyebrow">Follow the horizon</span>
        <SocialIcons className="mt-4" size={20} />
        <p className="mt-6 text-xs text-slate-500">openhorizonrecords@outlook.com</p>
      </div>
    </div>
    <div className="border-t border-white/5 py-6 text-center text-xs tracking-[0.3em] uppercase text-slate-500">
      Open Horizon Records — Music Beyond The Horizon
    </div>
  </footer>
);
